export default {
    produto: {},
    loading: false
}